import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";

function App() {
    return (
        <div className="App grain min-h-screen bg-[#050505] text-white">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
